// src/pages/Home.jsx
import React from "react";
import UserDashboard from "./UserDashboard";

/**
 * Home is now the main user landing page.
 * It simply renders the UserDashboard experience.
 */
export default function Home() {
  return <UserDashboard />;
}
